module.exports = __webpack_public_path__ + "media/4x3/tc-d40761f2.svg";